export default "__VITE_ASSET__CLFVPxnA__"